module.exports = __webpack_public_path__ + "img/pdf.8dc74ce9.png";